export enum RegisterContextActions {
  SET_STEP_COMPLETED = 'SET_STEP_COMPLETED',
  SET_STEP_ID = 'SET_STEP_ID',
  SET_STATUS = 'SET_STATUS',
  SET_INITIAL_STATUS = 'SET_INITIAL_STATUS',
  SET_EVENT_STATUS = 'SET_EVENT_STATUS',
  SET_MAXIMUM_QUANTITY_ASSOCIATES = 'SET_MAXIMUM_QUANTITY_ASSOCIATES',
  SET_SHOW_ALERT = 'SET_SHOW_ALERT',
  SET_TO_PAGE = 'SET_TO_PAGE',

  // Data step
  DATA_FILTER_SET = 'DATA_FILTER_SET',
  DATA_FILTER_SET_OLD = 'DATA_FILTER_SET_OLD',
  DATA_ASSEMBLY_TYPE = 'DATA_ASSEMBLY_TYPE',
  DATA_ASSEMBLY_LINK = 'DATA_ASSEMBLY_LINK',
  DATA_ASSEMBLY_COOPERATIVE = 'DATA_ASSEMBLY_COOPERATIVE',
  DATA_ASSEMBLY_MODALITY = 'DATA_ASSEMBLY_MODALITY',
  DATA_ASSEMBLY_TYPE_LOAD = 'DATA_ASSEMBLY_TYPE_LOAD',
  DATA_ASSEMBLY_COOPERATIVE_LOAD = 'DATA_ASSEMBLY_COOPERATIVE_LOAD',
  DATA_ASSEMBLY_MODALITY_LOAD = 'DATA_ASSEMBLY_MODALITY_LOAD',
  DATA_ASSEMBLY_LINK_LOAD = 'DATA_ASSEMBLY_LINK_LOAD',

  // Entity step
  ENTITIES_FILTER_SET = 'ENTITIES_FILTER_SET',
  ENTITIES_AGENCY = 'ENTITIES_AGENCY',
  ENTITIES_NUCLEOU = 'ENTITIES_NUCLEOU',
  ENTITIES_TABLE_DATA = 'ENTITIES_TABLE_DATA',
  ENTITIES_TABLE_DATA_OLD = 'ENTITIES_TABLE_DATA_OLD',
  ENTITIES_ALL_NUCLEOU_PER_AGENCY = 'ENTITIES_ALL_NUCLEOU_PER_AGENCY',
  ENTITIES_AGENCY_LOAD = 'ENTITIES_AGENCY_LOAD',
  ENTITIES_NUCLEOU_LOAD = 'ENTITIES_NUCLEOU_LOAD',

  // Local step
  LOCAL_FILTER_SET = 'LOCAL_FILTER_SET',
  LOCAL_FILTER_SET_OLD = 'LOCAL_FILTER_SET_OLD',
  LOCAL_STATES_OPTIONS = 'LOCAL_STATES_OPTIONS',
  LOCAL_CITIES_OPTIONS = 'LOCAL_CITIES_OPTIONS',
  LOCAL_LOAD = 'LOCAL_LOAD',

  // Staves step
  STAVES_TABLE_DATA = 'STAVES_TABLE_DATA',
  STAVES_INITIAL_TABLE_DATA = 'STAVES_INITIAL_TABLE_DATA',

  // Survey step
  SURVEY_FILTER_SET = 'SURVEY_FILTER_SET',
  SURVEY_FILTER_SET_OLD = 'SURVEY_FILTER_SET_OLD',
  SURVEY_TEMPLATES = 'SURVEY_TEMPLATES',
  SURVEY_TEMPLATES_LOAD = 'SURVEY_TEMPLATES_LOAD',
  SET_SURVEY_TEMPLATES = 'SURVEY_TEMPLATE',

  // Attachment step
  ATTACHMENT_TABLE_DATA = 'ATTACHMENT_TABLE_DATA',
}
